import React, {useState} from "react";
import Text from "../../styles/Text";
import AuthContainer from "../../containers/AuthContainer";
import {Content} from "../../styles/GlobalStyles";
import {ContentAuth, CardAuth, TitleAuth, CardOptions, FormAuth, InputAuth} from "../auth/components/AuthStyles";
import styled from "styled-components";
import {ButtonSubmit} from "../../components/footer/styles";
import Color from "../../assets/Colors";
import AppLoader from "../../components/loaders/Loader";
import useQuery from "../../hooks/useQuery";
import {ChangePasswordServie} from "../../services/UserServices";

export default function ChangePassword() {
   const [isLoading, setLoading] = useState(false);
   const [errorPass, setErrorPass] = useState("");
   const [success, setSuccess] = useState(false);

   let query = useQuery();
   const isOpen = query.get("newsLetter") === "true" ? true : false;

   const updatePass = (e) => {
      e.preventDefault();
      setLoading(true);
      let pwd = e.target.password.value;
      let password = e.target.passwordTwo.value;
      if (pwd === password) {
         let token = query.get("token");
         let toSend = {
            token,
            pwd,
         };
         ChangePasswordServie(toSend)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               console.log(resp);
               setSuccess(true);
            })
            .then(() => {
               setLoading(false);
            })
            .catch((e) => {
               console.log(e);
               setErrorPass("Algo salió mal, intenta más tarde");
               setLoading(false);
            });
      } else {
         setErrorPass("Las contraseñas no coinciden");
         setLoading(false);
      }
   };

   return (
      <>
         <AuthContainer>
            <Content>
               <ContentAuth>
                  <CardAuth>
                     {success ? (
                        <>
                           <div className="head">
                              <TitleAuth>Contraseña actualizada</TitleAuth>
                           </div>
                           <CardOptions></CardOptions>
                        </>
                     ) : (
                        <>
                           <div className="head">
                              <TitleAuth>Recuperar contraseña</TitleAuth>
                           </div>
                           <CardOptions>
                              <FormAuth onSubmit={updatePass}>
                                 <InputAuth type="password" name="password" placeholder="Contraseña" />
                                 <InputAuth type="password" name="passwordTwo" placeholder="Confirmar contraseña" />

                                 <InitButton>CAMBIAR CONTRASEÑA</InitButton>
                                 {errorPass && <Text color="crimson">{errorPass}</Text>}
                              </FormAuth>
                           </CardOptions>
                        </>
                     )}
                  </CardAuth>
               </ContentAuth>
            </Content>
         </AuthContainer>
         <AppLoader isVisible={isLoading} />
      </>
   );
}

const InitButton = styled(ButtonSubmit)`
   padding: 0.5em 1em;
   color: ${Color.primary};
   margin-top: 2em;
   margin-bottom: 1em;
`;
